import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Organization } from 'entities/organization'
import { ReactNode, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'
import { OrganizationViewModel } from 'view_models/organization_view_model'

export const organizationColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'organization_id', searchType: { name: 'id', type: 'multiple_text' } },
            {
                name: '施設コード',
                th: true,
                width: 90,
                align: 'center',
                form: form,
                orderAttr: 'organization_code',
                searchType: { name: 'code', type: 'text' },
            },
            { name: '施設名', th: true, width: 250, form: form, orderAttr: 'organization_name', searchType: { name: 'nameIn', type: 'text' } },
            { name: '施設数', th: true, width: 120, align: 'center' },
            {
                name: '電話番号',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'organization_tel',
                searchType: { name: 'tel', type: 'text' },
            },
            {
                name: '住所',
                th: true,
                minWidth: 300,
                form: form,
                orderAttr: 'organization_address_id',
                searchType: { name: 'address', type: 'text' },
            },
        ],
    }
}

export type OrganizationTableDataProps = {
    organization?: Organization
    displaySetting: DisplaySetting
}

export const OrganizationTableData = ({ organization, displaySetting }: OrganizationTableDataProps): JSX.Element => {
    if (!organization) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new OrganizationViewModel(organization)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{organization.id}</TableCell>
                <TableCell align="center">{organization.code}</TableCell>
                <TableCell>{organization.name}</TableCell>
                <TableCell align="center">
                    <Link to={`institutions?organizationId=${organization.id}`}>{organization.institutions?.length} 施設</Link>
                </TableCell>
                <TableCell>{organization.tel}</TableCell>
                <TableCell>{vm.addressVm().wholeView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
